import type { EventStatus } from '../../config';

const FEW_SEATS_THRESHOLD = 3;

const EVENT_TIMEZONE_OFFSET = '+03:00';

export function buildStartAt(dateStartAt: string, timeStartAt: string): string {
  const datePart = dateStartAt.slice(0, 10);
  const timeHm = timeStartAt.slice(0, 5);
  return `${datePart}T${timeHm}:00${EVENT_TIMEZONE_OFFSET}`;
}

export function buildEndAt(dateStartAt: string, timeEndAt: string): string {
  const datePart = dateStartAt.slice(0, 10);
  const timeHm = timeEndAt.slice(0, 5);
  return `${datePart}T${timeHm}:00${EVENT_TIMEZONE_OFFSET}`;
}

export function deriveStatus(availableSeats: number): EventStatus {
  if (availableSeats === 0) {
    return 'soldOut';
  }
  if (availableSeats <= FEW_SEATS_THRESHOLD) {
    return 'fewLeft';
  }
  return 'available';
}

export function isPastEventEnd(endAtIso: string): boolean {
  const endMs = new Date(endAtIso).getTime();
  return Number.isFinite(endMs) && Date.now() > endMs;
}
